import { TenantEntity } from '../TenantEntity'

export class SeaEQ extends TenantEntity {
  /**
   * @param {Object} data
   */
  constructor(data) {
    super(data)
  }
  get joinContainerId() {
    return this._data.joinContainerId
  }
  set joinContainerId(joinContainerId) {
    this._data.joinContainerId = joinContainerId || 0
  }

  get eqId() {
    return this._data.eqId
  }
  set eqId(eqId) {
    this._data.eqId = eqId || 0
  }
  get eqSize() {
    return this._data.eqSize
  }
  set eqSize(eqSize) {
    this._data.eqSize = eqSize
  }
  get eqType() {
    return this._data.eqType
  }
  set eqType(eqType) {
    this._data.eqType = eqType
  }
  get eqQuantity() {
    return this._data.eqQuantity
  }
  set eqQuantity(eqQuantity) {
    this._data.eqQuantity = eqQuantity || 0
  }
  get containerNo() {
    return this._data.containerNo
  }
  set containerNo(containerNo) {
    this._data.containerNo = containerNo
  }
  get sealNo() {
    return this._data.sealNo
  }
  set sealNo(sealNo) {
    this._data.sealNo = sealNo
  }
  get soc() {
    return this._data.soc
  }
  set soc(soc) {
    this._data.soc = soc || false
  }
  get sizeLength() {
    return this._data.sizeLength
  }
  set sizeLength(sizeLength) {
    this._data.sizeLength = sizeLength || 0
  }
  get sizeWidth() {
    return this._data.sizeWidth
  }
  set sizeWidth(sizeWidth) {
    this._data.sizeWidth = sizeWidth || 0
  }
  get sizeHeight() {
    return this._data.sizeHeight
  }
  set sizeHeight(sizeHeight) {
    this._data.sizeHeight = sizeHeight || 0
  }
  get jobUuid() {
    return this._data.jobUuid
  }
  set jobUuid(jobUuid) {
    this._data.jobUuid = jobUuid
  }
  get trustFromSeaEq() {
    return this._data.trustFromSeaEq
  }
  set trustFromSeaEq(trustFromSeaEq) {
    this._data.trustFromSeaEq = trustFromSeaEq
  }
}
